/**
 * Wrapper for all pages
 * - injects cookie consent and support for Google Analytics
 * - provides Figma styles
 * - provides default SiteMetadata data to the Airtable <SEO /> component
 */
import React from 'react'

import CMS from '@talus-analytics/library.airtable-cms'
import FigmaProvider from '../../figma/FigmaProvider'
import useSiteMetadata from '../../hooks/useSiteMetadata'
import getTrackingId from '../../utilities/trackingId'

interface ProvidersProps {
  children: JSX.Element | JSX.Element[]
}
const Providers = ({ children }: ProvidersProps): JSX.Element => {
  // get SEO data
  const seoData = useSiteMetadata()
  // get GA tracking ID
  const trackingId = getTrackingId()

  return (
    <CMS.SiteMetadataProvider data={seoData} trackingId={trackingId}>
      <FigmaProvider>{children}</FigmaProvider>
    </CMS.SiteMetadataProvider>
  )
}

export default Providers
